import {createRoot} from 'react-dom/client';
import { PorscheDesignSystemProvider } from "@porsche-design-system/components-react";

import App from "./App";
import { ModelStateProvider } from "./store/ModelContext";

const root = createRoot(
	document.getElementById("root")
);

root.render(
	<PorscheDesignSystemProvider prefix={"lena"}>
		<ModelStateProvider>
			<App />
		</ModelStateProvider>
	</PorscheDesignSystemProvider>
);

